import { consoleSandbox } from '@sentry/core';
import { FAKE_FUNCTION } from './common.js';

const REPLAY_INTEGRATION_METHODS = ["start", "stop", "flush"];
function replayIntegrationShim(_options) {
  consoleSandbox(() => {
    console.warn("You are using replayIntegration() even though this bundle does not include replay.");
  });
  return {
    name: "Replay",
    ...REPLAY_INTEGRATION_METHODS.reduce((acc, method) => {
      acc[method] = FAKE_FUNCTION;
      return acc;
    }, {})
  };
}

export { replayIntegrationShim };
//# sourceMappingURL=Replay.js.map
